import { ControlIcons } from 'owa-control-icons';
import {
    createLinkPreviewBorder,
    BaseLinkPreviewObject,
    LinkPreviewType,
} from './BaseLinkPreviewObject';
import * as Constants from './constants';
import { PreviewSize } from './updatePreviewSize';
import {
    createDomElementsForWebpageLinkPreview,
    rehydrateWebPageLinkPreview,
    updateWebpageLinkPreviewSize,
    WebpageLinkPreviewObject,
} from './WebpageLinkPreviewObject';
import getLinkPreview from '../services/getLinkPreview';
import { Icon } from '@fluentui/react/lib/Icon';
import BingVideoLinkPreview from 'owa-service/lib/contract/BingVideoLinkPreview';
import GetLinkPreviewResponse from 'owa-service/lib/contract/GetLinkPreviewResponse';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

let videoPlayerStyles = require('../styles/videoPlayerStyles.scss');
const REHYDRATE_ID = 'rehydrate';

export interface VideoLinkPreviewObject extends WebpageLinkPreviewObject {
    videoUrl: string;
    videoPlayer: string;
    motionThumbnail?: string;

    playVideoButtonContainer?: HTMLDivElement;
}

export function createVideoLinkPreviewObject(
    linkPreview: BingVideoLinkPreview,
    anchor: HTMLAnchorElement,
    inCompose: boolean
): VideoLinkPreviewObject {
    let lp: VideoLinkPreviewObject = {
        type: LinkPreviewType.VideoPreview,
        description: linkPreview.Description,
        title: linkPreview.Title,
        url: linkPreview.Url,
        thumbnailImageUrl: linkPreview.ImageUrl,
        anchor: anchor,
        videoUrl: linkPreview.Url,
        videoPlayer: linkPreview.EmbeddedHtml,
        motionThumbnail: linkPreview.MotionThumbnailUrl,
    };

    // For now, just use the exact same style as the webpage link previews.
    createLinkPreviewBorder(Constants.LINK_PREVIEW_BORDER_VIDEO_TYPE, lp);
    createDomElementsForWebpageLinkPreview(lp, inCompose);

    return lp;
}

export async function rehydrateVideoLinkPreview(
    div: HTMLDivElement
): Promise<BaseLinkPreviewObject> {
    let linkPreviewObject = (await rehydrateWebPageLinkPreview(div)) as VideoLinkPreviewObject;
    linkPreviewObject.type = LinkPreviewType.VideoPreview;
    linkPreviewObject.videoUrl = linkPreviewObject.url;
    linkPreviewObject.videoPlayer = null;
    linkPreviewObject.motionThumbnail = null;
    linkPreviewObject.playVideoButtonContainer = null;

    // The relative position property on the image container may have been stripped after sent, and it is needed to ensure
    // that the play button is positioned properly, so add it back now
    if (linkPreviewObject.thumbnailImageContainer) {
        linkPreviewObject.thumbnailImageContainer.style.position = 'relative';
    }

    return getLinkPreview(linkPreviewObject.videoUrl, REHYDRATE_ID).then(
        (response: GetLinkPreviewResponse) => {
            if (response.LinkPreview?.__type == Constants.BING_VIDEO_LINK_PREVIEW_TYPE) {
                linkPreviewObject.videoPlayer = (response.LinkPreview as BingVideoLinkPreview).EmbeddedHtml;
            }

            return linkPreviewObject;
        }
    );
}

export function addPlayButton(lp: VideoLinkPreviewObject) {
    lp.playVideoButtonContainer = document.createElement('div');
    lp.playVideoButtonContainer.id = Constants.createLinkPreviewId(
        lp.border.className,
        Constants.LINK_PREVIEW_PLAY_BUTTON_ID
    );
    lp.playVideoButtonContainer.className = videoPlayerStyles.playButtonContainer;

    ReactDOM.render(
        <Icon iconName={ControlIcons.Play} className={videoPlayerStyles.playButtonIcon} />,
        lp.playVideoButtonContainer
    );

    lp.thumbnailImageContainer.appendChild(lp.playVideoButtonContainer);
}

export function updateVideoLinkPreviewSize(
    linkPreview: VideoLinkPreviewObject,
    previewSize: PreviewSize
) {
    updateWebpageLinkPreviewSize(linkPreview, previewSize);
}
